import {
  createCampaign,
  getCampaigns,
  updateCampaign,
} from "./CampaignActions";
import {
  assignPlan,
  assignTour,
  reassignTour,
  upload3plTourCsv,
  uploadTourCsv,
} from "./ShipperActions";
import {
  bulkUploadProduct,
  clearProductDetailsAction,
  createGlobalProduct,
  fetchDeliveryOptions,
  fetchProductBrands,
  fetchProductTypes,
  fetchProductUom,
  fetchTaxFromOdoo,
  fetchWareHouseNames,
  getGlobalProductDetails,
  inventoryUploadProduct,
  updateGlobalProduct,
  uploadImageAndCreateUpdateGlobalProductAction,
} from "./GlobalProductActions";

// import {
//   fetchWareHouseNames2,
// } from "./DeliveryDateActions";
import {
  bulkUploadProductCityLevel,
  clearProductCityLevelDetailsAction,
  fetchProductCityLevelBrands,
  fetchProductCityLevelInventory,
  getProductCityLevels,
  inventoryUploadProductCityLevel,
  productCityLevelFetchTaxFromOdoo,
  productCityLevelFetchWareHouseNames,
  updateProductCityLevelInventory,
  newProductCityLevelPriceUpload,
} from "./ProductCityLevelActions";
import {
  clearBulkCustomerDetailsAction,
  clearCustomerDetailsNewAction,
  createCustomer,
  createStore,
  fetchCustomerConfig,
  fetchCustomerZoneApiActions,
  fetchStoreType,
  getBulkCustomerDetailsByIdAction,
  getCustomerDetailsNewAction,
  getCustomers,
  updateCustomerAction,
} from "./CustomerActions";
import {
  clearOrderDetailsAction,
  createOrder,
  getOrderDetails,
  getOrderPriceBreakdown,
  getOrders,
  getPromosForOrder,
  updateOrder,
  updateOrderStatus,
} from "./OrderActions";
import {
  clearPromoCityLevelDetailsAction,
  createBasketPromoCityLevel,
  createPromoCityLevel,
  createUploadUserLevelPromoActions,
  getPromoCityLevelByType,
  getPromoCityLevelDetails,
  getPromosCityLevel,
  getUCByCityIdActions,
  getWarehouseByCityIdActions,
  updatePromoCityLevelStatus,
  updatePromoCityLevelActions,
  uploadUserLevelPromoActions,
  createPromoBulkActions,
  deactivatePromoBulkActions,
} from "./PromoCityLevelActions";
import {
  createAccessControlUserWithClientAndRoles,
  clearAccessControlUserLevelDetailsAction,
  getAccessControlUserDetailsNewAction,
  clearAccessControlUserLevelDetails,
  getAccessControlUsers,
  getAllRolesAndClients,
  updateAccessControlUserWithClientAndRoles,
  fetchAllFilters,
} from "./AccessControlActions";
import {
  createAgentUserWithTypeTeamZones,
  fetchAgentTeam,
  fetchAgentTitle,
  getAgentDetailAction,
  getAgentListAction,
  getAllAgentZonesAction,
  updateAgentUserWithTypeTeamZones,
  fetchBrands,
  createAgentWithTypeTeamZones,
} from "./AgentManagementActions";
import {
  fetchCategoriesForCity,
  fetchCategoryProductsForCity,
  getCategoriesList,
  reorderCategoryProductsForCity,
  updateCityLevelCategory,
} from "./CategoryActions";
import {
  createCategoryGlobal,
  getCategoriesGlobalList,
  getCoreCategoriesGlobal,
  updateCategoryGlobal,
} from "./CategoryGlobalActions";
import {
  endWarehouseShift,
  startWarehouseShift,
  uploadTourCsvForWarehouseShiftAndUpdateShiftEvent,
} from "./WarehouseOpsActions";
import {
  getBanners,
  updateBanner,
  updateBannerAndProducts,
  updateBannerSequence,
  uploadBannerImageAction,
  uploadImageAndUpdateBannerAndProducts,
} from "./BannerActions";
import {
  getMfaSession,
  login,
  validateMfaSession,
  mfaFallbackSession,
  validateKeycloakSessionAction,
} from "./AuthActions";

import { bulkUploadStoreListing } from "./StoreListingActions";
import {
  createRider,
  createRiderUser,
  downloadLocusCsvAction,
  getRiderJobTypesAction,
  getRiderManagementList,
  getRiderUserDetailsAction,
  updateRiderUser,
  downloadPlanOutputCsvAction,
} from "./RiderManagementActions";
import { fetchCities } from "./ZoneActions";

import {
  getZonalConfigsList,
  zonalBoundaryConfigUpload,
  createZonalConfig,
  updateZonalConfig,
  clearZonalConfigDetailsAction,
  fetchZonalConfigWareHouseNames,
  getZonalConfigChildZonesAction,
  getZonalConfigTownsAction,
  getZonalConfigWarehouseAction,
  fetchZonalConfigWarehouseListWithStorageBlocksAction,
  zonalServiceCSVBatchUpload,
  getZonalCustomerChannel,
} from "./ZonalConfigActions";
import {
  getCnicVerificationDataAction,
  verifyCnicDataAction,
} from "./CnicVerificationActions";
import {
  createUpdateWarehouseDeliveryDateConfigAction,
  fetchByCityWareHouseListDeliveryDateAction,
  fetchWarehouseDeliveryDateConfigAction,
} from "./DeliveryDateActions";

import {
  CategoriesForMetricsAction,
  createUpdateMetrics,
  getAllCoreMetricsAction,
  getMetricsDetailsAction,
  metricsUpload,
} from "./MetricsActions";
import {
  createPaiyaGiftUploadCsvAction,
  createPaiyaMovGameStatusAction,
  createPaiyaStoreUploadCsvAction,
  fetchPaiyaConfigAction,
  fetchPaiyaTypesAction,
} from "./PaiyaTypeActions";

import {
  createStaff,
  createStaffWithUser,
  fetchWarehouseStaffListing,
  getAllJobTypes,
  getAllWarehouses,
  getWarehouseStaffUserDetails,
  updateStaffWithUser,
} from "./WarehouseStaffActions";
import {
  createNewsfeedAction,
  getNewsfeedListAction,
  updateNewsfeedAction,
} from "./NewsfeedActions";

import { updateDeliveryDateInLiveops } from "./LiveopsActions";
import {
  agentChatwootAssignment,
  agentStoreAssignment,
} from "./AgentAssignmentActions";

import {
  uploadImageAndCreatePaiyaGiftAction,
  fetchPaiyaGifts,
  clearPaiyaGiftDetails,
} from "./PaiyaGiftActions";

import {
  fetchUserCreditLimit,
  fetchCreditUser,
  fetchCreditPaymentPlans,
  clearCreditLimitAndPlansAction,
} from "./CreditActions";

export default {
  reassignTour,
  createCustomer,
  getCustomers,
  login,
  getCustomerDetailsNewAction,
  getBulkCustomerDetailsByIdAction,
  clearBulkCustomerDetailsAction,
  clearCustomerDetailsNewAction,
  updateCustomerAction,
  fetchStoreType,
  fetchCustomerConfig,
  fetchCustomerZoneApiActions,
  createGlobalProduct,
  fetchProductTypes,
  fetchProductUom,
  bulkUploadProduct,
  inventoryUploadProduct,
  getGlobalProductDetails,
  updateGlobalProduct,
  clearProductDetailsAction,
  getCategoriesList,
  fetchCategoriesForCity,
  createOrder,
  getOrders,
  getOrderDetails,
  clearOrderDetailsAction,
  updateCityLevelCategory,
  updateOrder,
  updateOrderStatus,
  uploadImageAndCreateUpdateGlobalProductAction,
  fetchCategoryProductsForCity,
  reorderCategoryProductsForCity,
  getAccessControlUsers,
  getAccessControlUserDetailsNewAction,
  clearAccessControlUserLevelDetails,
  getAllRolesAndClients,
  createAccessControlUserWithClientAndRoles,
  updateAccessControlUserWithClientAndRoles,
  fetchProductBrands,
  bulkUploadStoreListing,
  fetchWareHouseNames,
  fetchTaxFromOdoo,
  getAgentListAction,
  getAgentDetailAction,
  getAllAgentZonesAction,
  createAgentWithTypeTeamZones,
  createAgentUserWithTypeTeamZones,
  updateAgentUserWithTypeTeamZones,
  fetchAgentTitle,
  fetchAgentTeam,
  fetchBrands,
  assignTour,
  createStore,
  fetchCities,
  assignPlan,
  getBanners,
  updateBanner,
  uploadImageAndUpdateBannerAndProducts,
  updateBannerAndProducts,
  getProductCityLevels,
  bulkUploadProductCityLevel,
  inventoryUploadProductCityLevel,
  clearProductCityLevelDetailsAction,
  fetchProductCityLevelBrands,
  fetchProductCityLevelInventory,
  updateProductCityLevelInventory,
  getPromosForOrder,
  productCityLevelFetchWareHouseNames,
  getMfaSession,
  productCityLevelFetchTaxFromOdoo,
  uploadTourCsv,
  upload3plTourCsv,
  getCategoriesGlobalList,
  createCategoryGlobal,
  updateCategoryGlobal,
  getCoreCategoriesGlobal,
  validateMfaSession,
  mfaFallbackSession,
  createRiderUser,
  updateRiderUser,
  getRiderManagementList,
  clearPromoCityLevelDetailsAction,
  clearAccessControlUserLevelDetailsAction,
  createBasketPromoCityLevel,
  createPromoCityLevel,
  createPromoBulkActions,
  deactivatePromoBulkActions,
  getPromoCityLevelByType,
  getWarehouseByCityIdActions,
  getUCByCityIdActions,
  uploadUserLevelPromoActions,
  createUploadUserLevelPromoActions,
  getPromoCityLevelDetails,
  getPromosCityLevel,
  updatePromoCityLevelStatus,
  updatePromoCityLevelActions,
  startWarehouseShift,
  endWarehouseShift,
  uploadTourCsvForWarehouseShiftAndUpdateShiftEvent,
  getRiderUserDetailsAction,
  createRider,
  createCampaign,
  getCampaigns,
  getZonalConfigsList,
  zonalBoundaryConfigUpload,
  zonalServiceCSVBatchUpload,
  createZonalConfig,
  updateZonalConfig,
  clearZonalConfigDetailsAction,
  fetchZonalConfigWareHouseNames,
  getZonalConfigChildZonesAction,
  getZonalConfigTownsAction,
  getZonalConfigWarehouseAction,
  getZonalCustomerChannel,
  updateCampaign,
  downloadLocusCsvAction,
  getCnicVerificationDataAction,
  verifyCnicDataAction,
  fetchDeliveryOptions,
  fetchByCityWareHouseListDeliveryDateAction,
  fetchWarehouseDeliveryDateConfigAction,
  createUpdateWarehouseDeliveryDateConfigAction,
  createUpdateMetrics,
  getMetricsDetailsAction,
  getAllCoreMetricsAction,
  CategoriesForMetricsAction,
  metricsUpload,
  getOrderPriceBreakdown,
  fetchPaiyaTypesAction,
  fetchPaiyaConfigAction,
  createPaiyaStoreUploadCsvAction,
  createPaiyaGiftUploadCsvAction,
  createPaiyaMovGameStatusAction,
  createStaffWithUser,
  createStaff,
  updateStaffWithUser,
  getAllWarehouses,
  getAllJobTypes,
  getWarehouseStaffUserDetails,
  fetchWarehouseStaffListing,
  getNewsfeedListAction,
  createNewsfeedAction,
  updateNewsfeedAction,
  updateDeliveryDateInLiveops,
  getRiderJobTypesAction,
  updateBannerSequence,
  uploadBannerImageAction,
  agentChatwootAssignment,
  agentStoreAssignment,
  fetchAllFilters,
  newProductCityLevelPriceUpload,
  uploadImageAndCreatePaiyaGiftAction,
  fetchPaiyaGifts,
  clearPaiyaGiftDetails,
  downloadPlanOutputCsvAction,
  fetchZonalConfigWarehouseListWithStorageBlocksAction,
  fetchUserCreditLimit,
  fetchCreditPaymentPlans,
  clearCreditLimitAndPlansAction,
  fetchCreditUser,
  validateKeycloakSessionAction,
};
